"use client"

import Cookies from "js-cookie"

// Simple client-side storage utilities to simulate auth until APIs exist.

type StoredUser = {
  phone: string
  firstName: string
  lastName: string
}

const USERS_KEY = "qetero.users"
const CURRENT_USER_PHONE_KEY = "qetero.currentUserPhone"
const PENDING_PHONE_KEY = "qetero.pendingPhone"
const SELECTED_BRANCH_KEY = "qetero.selectedBranchId"

function getUsers(): Record<string, StoredUser> {
  try {
    const raw = window.localStorage.getItem(USERS_KEY)
    return raw ? (JSON.parse(raw) as Record<string, StoredUser>) : {}
  } catch {
    return {}
  }
}

function setUsers(users: Record<string, StoredUser>): void {
  window.localStorage.setItem(USERS_KEY, JSON.stringify(users))
}

export function setPendingPhone(phone: string): void {
  Cookies.set(PENDING_PHONE_KEY, phone, { path: '/' })
}

export function getPendingPhone(): string | null {
  return Cookies.get(PENDING_PHONE_KEY) || null
}

export function clearPendingPhone(): void {
  Cookies.remove(PENDING_PHONE_KEY, { path: '/' })
}

export function userExists(phone: string): boolean {
  const users = getUsers()
  return Boolean(users[phone])
}

export function registerUser(user: StoredUser): void {
  const users = getUsers()
  users[user.phone] = user
  setUsers(users)
  window.localStorage.setItem(CURRENT_USER_PHONE_KEY, user.phone)
}

export function loginByPhone(phone: string): void {
  window.localStorage.setItem(CURRENT_USER_PHONE_KEY, phone)
}

export function getCurrentUser(): StoredUser | null {
  const phone = window.localStorage.getItem(CURRENT_USER_PHONE_KEY)
  if (!phone) return null
  const users = getUsers()
  return users[phone] ?? null
}

export function logout(): void {
  window.localStorage.removeItem(CURRENT_USER_PHONE_KEY)
}

export function setSelectedBranch(branchId: string): void {
  window.localStorage.setItem(SELECTED_BRANCH_KEY, branchId)
}

export function getSelectedBranch(): string | null {
  return window.localStorage.getItem(SELECTED_BRANCH_KEY)
}



